export const AVAILABLE_LOCALES: { [key: string]: string } = {
  en: 'English',
  ru: 'Russian',
  ja: 'Japanese',
  zh: 'Chinese',
  es: 'Spanish',
  pt: 'Portuguese',
  it: 'Italian',
  fr: 'French',
  cz: 'Czech',
  tr: 'Turkish',
  sv: 'Swedish',
  da: 'Danish',
  de: 'German',
  fi: 'Finnish'
};

export const AVAILABLE_LOCALES_EXTEND: { [key: string]: string } = {
  ...AVAILABLE_LOCALES,
  ko: 'Korean',
  jp: 'Jamaica',
  ca: 'Catalan',
  ms: 'Malay',
  id: 'Indonesian',
  th: 'Thai',
  nl: 'Dutch',
  ar: 'Arabic',
  he: 'Hebrew',
  nn: 'Norwegian'
};

export const AVAILABLE_FONTS: { [key: string]: string[] } = {
  "Academy Engraved LET": [
    "AcademyEngravedLetPlain"
  ],
  "Al Nile": [
    "AlNile-Bold",
    "AlNile"
  ],
  "American Typewriter": [
    "AmericanTypewriter-CondensedLight",
    "AmericanTypewriter",
    "AmericanTypewriter-CondensedBold",
    "AmericanTypewriter-Light",
    "AmericanTypewriter-Semibold",
    "AmericanTypewriter-Bold",
    "AmericanTypewriter-Condensed"
  ],
  "Apple Color Emoji": [
    "AppleColorEmoji"
  ],
  "Apple SD Gothic Neo": [
    "AppleSDGothicNeo-Bold",
    "AppleSDGothicNeo-UltraLight",
    "AppleSDGothicNeo-Thin",
    "AppleSDGothicNeo-Regular",
    "AppleSDGothicNeo-Light",
    "AppleSDGothicNeo-Medium",
    "AppleSDGothicNeo-SemiBold"
  ],
  "Arial": [
    "ArialMT",
    "Arial-BoldItalicMT",
    "Arial-BoldMT",
    "Arial-ItalicMT"
  ],
  "Arial Hebrew": [
    "ArialHebrew-Bold",
    "ArialHebrew-Light",
    "ArialHebrew"
  ],
  "Arial Rounded MT Bold": [
    "ArialRoundedMTBold"
  ],
  "Avenir": [
    "Avenir-Medium",
    "Avenir-HeavyOblique",
    "Avenir-Book",
    "Avenir-Light",
    "Avenir-Roman",
    "Avenir-BookOblique",
    "Avenir-MediumOblique",
    "Avenir-Black",
    "Avenir-BlackOblique",
    "Avenir-Heavy",
    "Avenir-LightOblique",
    "Avenir-Oblique"
  ],
  "Avenir Next": [
    "AvenirNext-UltraLight",
    "AvenirNext-UltraLightItalic",
    "AvenirNext-Bold",
    "AvenirNext-BoldItalic",
    "AvenirNext-DemiBold",
    "AvenirNext-DemiBoldItalic",
    "AvenirNext-Medium",
    "AvenirNext-HeavyItalic",
    "AvenirNext-Heavy",
    "AvenirNext-Italic",
    "AvenirNext-Regular",
    "AvenirNext-MediumItalic"
  ],
  "Avenir Next Condensed": [
    "AvenirNextCondensed-BoldItalic",
    "AvenirNextCondensed-Heavy",
    "AvenirNextCondensed-Medium",
    "AvenirNextCondensed-Regular",
    "AvenirNextCondensed-HeavyItalic",
    "AvenirNextCondensed-MediumItalic",
    "AvenirNextCondensed-Italic",
    "AvenirNextCondensed-UltraLightItalic",
    "AvenirNextCondensed-UltraLight",
    "AvenirNextCondensed-DemiBold",
    "AvenirNextCondensed-Bold",
    "AvenirNextCondensed-DemiBoldItalic"
  ],
  "Bangla Sangam MN": [
  ],
  "Baskerville": [
    "Baskerville-Italic",
    "Baskerville-SemiBold",
    "Baskerville-BoldItalic",
    "Baskerville-SemiBoldItalic",
    "Baskerville-Bold",
    "Baskerville"
  ],
  "Bodoni 72": [
    "BodoniSvtyTwoITCTT-Bold",
    "BodoniSvtyTwoITCTT-Book",
    "BodoniSvtyTwoITCTT-BookIta"
  ],
  "Bodoni 72 Oldstyle": [
    "BodoniSvtyTwoOSITCTT-Book",
    "BodoniSvtyTwoOSITCTT-Bold",
    "BodoniSvtyTwoOSITCTT-BookIt"
  ],
  "Bodoni 72 Smallcaps": [
    "BodoniSvtyTwoSCITCTT-Book"
  ],
  "Bodoni Ornaments": [
    "BodoniOrnamentsITCTT"
  ],
  "Bradley Hand": [
    "BradleyHandITCTT-Bold"
  ],
  "Chalkboard SE": [
    "ChalkboardSE-Bold",
    "ChalkboardSE-Light",
    "ChalkboardSE-Regular"
  ],
  "Chalkduster": [
    "Chalkduster"
  ],
  "Cochin": [
    "Cochin-Bold",
    "Cochin",
    "Cochin-Italic",
    "Cochin-BoldItalic"
  ],
  "Copperplate": [
    "Copperplate-Light",
    "Copperplate",
    "Copperplate-Bold"
  ],
  "Courier": [
    "Courier-BoldOblique",
    "Courier",
    "Courier-Bold",
    "Courier-Oblique"
  ],
  "Courier New": [
    "CourierNewPS-BoldMT",
    "CourierNewPS-ItalicMT",
    "CourierNewPSMT",
    "CourierNewPS-BoldItalicMT"
  ],
  "Damascus": [
    "DamascusLight",
    "DamascusBold",
    "DamascusSemiBold",
    "DamascusMedium",
    "Damascus"
  ],
  "Devanagari Sangam MN": [
    "DevanagariSangamMN",
    "DevanagariSangamMN-Bold"
  ],
  "Didot": [
    "Didot-Italic",
    "Didot-Bold",
    "Didot"
  ],
  "Euphemia UCAS": [
    "EuphemiaUCAS-Italic",
    "EuphemiaUCAS",
    "EuphemiaUCAS-Bold"
  ],
  "Farah": [
    "Farah"
  ],
  "Futura": [
    "Futura-CondensedMedium",
    "Futura-CondensedExtraBold",
    "Futura-Medium",
    "Futura-MediumItalic",
    "Futura-Bold"
  ],
  "Geeza Pro": [
    "GeezaPro",
    "GeezaPro-Bold"
  ],
  "Georgia": [
    "Georgia-BoldItalic",
    "Georgia",
    "Georgia-Italic",
    "Georgia-Bold"
  ],
  "Gill Sans": [
    "GillSans-Italic",
    "GillSans-Bold",
    "GillSans-BoldItalic",
    "GillSans-LightItalic",
    "GillSans",
    "GillSans-Light",
    "GillSans-SemiBold",
    "GillSans-SemiBoldItalic",
    "GillSans-UltraBold"
  ],
  "Gujarati Sangam MN": [
    "GujaratiSangamMN-Bold",
    "GujaratiSangamMN"
  ],
  "Gurmukhi MN": [
    "GurmukhiMN-Bold",
    "GurmukhiMN"
  ],
  "Heiti SC": [
  ],
  "Heiti TC": [
  ],
  "Helvetica": [
    "Helvetica-Bold",
    "Helvetica",
    "Helvetica-LightOblique",
    "Helvetica-Oblique",
    "Helvetica-BoldOblique",
    "Helvetica-Light"
  ],
  "Helvetica Neue": [
    "HelveticaNeue-Italic",
    "HelveticaNeue-Bold",
    "HelveticaNeue-UltraLight",
    "HelveticaNeue-CondensedBlack",
    "HelveticaNeue-BoldItalic",
    "HelveticaNeue-CondensedBold",
    "HelveticaNeue-Medium",
    "HelveticaNeue-Light",
    "HelveticaNeue-Thin",
    "HelveticaNeue-ThinItalic",
    "HelveticaNeue-LightItalic",
    "HelveticaNeue-UltraLightItalic",
    "HelveticaNeue-MediumItalic",
    "HelveticaNeue"
  ],
  "Hiragino Mincho ProN": [
    "HiraMinProN-W6",
    "HiraMinProN-W3"
  ],
  "Hiragino Sans": [
    "HiraginoSans-W3",
    "HiraginoSans-W6"
  ],
  "Hoefler Text": [
    "HoeflerText-Italic",
    "HoeflerText-Regular",
    "HoeflerText-Black",
    "HoeflerText-BlackItalic"
  ],
  "Kailasa": [
    "Kailasa-Bold",
    "Kailasa"
  ],
  "Kannada Sangam MN": [
    "KannadaSangamMN",
    "KannadaSangamMN-Bold"
  ],
  "Khmer Sangam MN": [
    "KhmerSangamMN"
  ],
  "Kohinoor Bangla": [
    "KohinoorBangla-Semibold",
    "KohinoorBangla-Regular",
    "KohinoorBangla-Light"
  ],
  "Kohinoor Devanagari": [
    "KohinoorDevanagari-Light",
    "KohinoorDevanagari-Regular",
    "KohinoorDevanagari-Semibold"
  ],
  "Kohinoor Telugu": [
    "KohinoorTelugu-Regular",
    "KohinoorTelugu-Medium",
    "KohinoorTelugu-Light"
  ],
  "Lao Sangam MN": [
    "LaoSangamMN"
  ],
  "Malayalam Sangam MN": [
    "MalayalamSangamMN-Bold",
    "MalayalamSangamMN"
  ],
  "Marker Felt": [
    "MarkerFelt-Thin",
    "MarkerFelt-Wide"
  ],
  "Menlo": [
    "Menlo-Italic",
    "Menlo-Bold",
    "Menlo-Regular",
    "Menlo-BoldItalic"
  ],
  "Mishafi": [
    "DiwanMishafi"
  ],
  "Myanmar Sangam MN": [
    "MyanmarSangamMN-Bold",
    "MyanmarSangamMN"
  ],
  "Noteworthy": [
    "Noteworthy-Light",
    "Noteworthy-Bold"
  ],
  "Optima": [
    "Optima-Regular",
    "Optima-ExtraBlack",
    "Optima-BoldItalic",
    "Optima-Italic",
    "Optima-Bold"
  ],
  "Oriya Sangam MN": [
    "OriyaSangamMN",
    "OriyaSangamMN-Bold"
  ],
  "Palatino": [
    "Palatino-Bold",
    "Palatino-Roman",
    "Palatino-BoldItalic",
    "Palatino-Italic"
  ],
  "Papyrus": [
    "Papyrus",
    "Papyrus-Condensed"
  ],
  "Party LET": [
    "PartyLetPlain"
  ],
  "PingFang HK": [
    "PingFangHK-Ultralight",
    "PingFangHK-Semibold",
    "PingFangHK-Thin",
    "PingFangHK-Light",
    "PingFangHK-Regular",
    "PingFangHK-Medium"
  ],
  "PingFang SC": [
    "PingFangSC-Ultralight",
    "PingFangSC-Regular",
    "PingFangSC-Semibold",
    "PingFangSC-Thin",
    "PingFangSC-Light",
    "PingFangSC-Medium"
  ],
  "PingFang TC": [
    "PingFangTC-Medium",
    "PingFangTC-Regular",
    "PingFangTC-Light",
    "PingFangTC-Ultralight",
    "PingFangTC-Semibold",
    "PingFangTC-Thin"
  ],
  "Savoye LET": [
    "SavoyeLetPlain"
  ],
  "Sinhala Sangam MN": [
    "SinhalaSangamMN-Bold",
    "SinhalaSangamMN"
  ],
  "Snell Roundhand": [
    "SnellRoundhand-Bold",
    "SnellRoundhand",
    "SnellRoundhand-Black"
  ],
  "Symbol": [
    "Symbol"
  ],
  "Tamil Sangam MN": [
    "TamilSangamMN",
    "TamilSangamMN-Bold"
  ],
  "Tangerine": [
    "Tangerine"
  ],
  "Telugu Sangam MN": [
  ],
  "Thonburi": [
    "Thonburi",
    "Thonburi-Bold",
    "Thonburi-Light"
  ],
  "Tienne": [
    "Tienne-Regular",
    "Tienne-Bold",
    "Tienne-Heavy"
  ],
  "Times New Roman": [
    "TimesNewRomanPSMT",
    "TimesNewRomanPS-BoldItalicMT",
    "TimesNewRomanPS-ItalicMT",
    "TimesNewRomanPS-BoldMT"
  ],
  "Trebuchet MS": [
    "Trebuchet-BoldItalic",
    "TrebuchetMS",
    "TrebuchetMS-Bold",
    "TrebuchetMS-Italic"
  ],
  "Verdana": [
    "Verdana-Italic",
    "Verdana-BoldItalic",
    "Verdana",
    "Verdana-Bold"
  ],
  "Zapf Dingbats": [
    "ZapfDingbatsITC"
  ],
  "Zapfino": [
    "Zapfino"
  ],
}
